import script from "./scrollArea.vue?vue&type=script&setup=true&lang=js"
export * from "./scrollArea.vue?vue&type=script&setup=true&lang=js"

import "./scrollArea.vue?vue&type=style&index=0&id=1e23d986&scoped=true&lang=css"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e23d986"]])

export default __exports__